import React from "react";
import ArrowUpward from '../components/ArrowUpward';
import GcpChart from '../components/GcpChart';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      fontSize: "2rem",
      color: "#FFFFFF",
      fontWeight: "bold",
      textAlign: 'center',
      margin: '10% 5% 5% 5%',
      // eslint-disable-next-line
      ['@media (min-width:780px)']: {
        fontSize: "3rem",
        marginTop: '5%',
      }
    },
  }),
);

const MySection: React.FC = () => {
  const classes = useStyles();
  return (
    <div className="section">
			<h2 className={classes.title}>GCP</h2>
      <GcpChart />
      <ArrowUpward />
    </div>
  );
}

export default MySection;
